// extracted by mini-css-extract-plugin
module.exports = {"container":"failed-to-load_container__1JUWv","title":"failed-to-load_title__3v-YN","description":"failed-to-load_description__O9rQM","noImage":"failed-to-load_noImage__2K8Wh"};